// LLM generated - Model Claude 4 Sonnet
import axios from 'axios';

import RequestHeadersBase from '~/common/constants/RequestHeadersBase';

import { handleRefreshInterceptor } from '../interceptors/handle-refresh.interceptor';
import { setAuthTokenInterceptor } from '../interceptors/set-auth-token.interceptor';

export const liveActivityService = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL_SPLASH}live-activity-service/api`,
  headers: {
    ...RequestHeadersBase,
  },
});

setAuthTokenInterceptor(liveActivityService);
handleRefreshInterceptor(liveActivityService);
